module.exports = __webpack_public_path__ + "img/bannerM.b643aeac.png";